import { faCheckSquare, faSquare, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './App.css';

function App() {

  const [password, setPassword] = React.useState<string>("fake");
  const [copied, setCopied] = React.useState<boolean>(false);

  const [includeUppercase, setIncludeUppercase] = React.useState<boolean>(true);
  const [includeLowercase, setIncludeLowercase] = React.useState<boolean>(true);
  const [includeNumbers, setIncludeNumbers] = React.useState<boolean>(true);
  const [includeSpecialChars, setIncludeSpecialChars] = React.useState<boolean>(false);
  const [passwordLength, setPasswordLength] = React.useState<number>(16); // Default length
  const [passwordClass, setPasswordClass] = React.useState<string>('password');
  const [withSeparators, setWithSeparators] = React.useState<boolean>(false);

  const addSeparators = (txt: string, n: number) => {
    var res = ""
    var i = 0;
    for (i = 0 ; i < txt.length - 1 ; i++){
      res += txt.charAt(i);
      if ((i+1) % n === 0){
        res += "-"
      }
    }
    res += txt.charAt(i)
    return res
  }

  const formatPassword = (txt: string) => {
    if (withSeparators){
      return addSeparators(txt, 4);
    } else {
      return txt;
    }
  }

  const [formattedPassword, setFormattedPassword] = React.useState<string>(formatPassword(password))
  
  const specialChars = '!@#$%^&*()_+~`|}{[:;?><,./=';
  const speciRegExp = /[!@#$%^&*()_+~`|}{[:;?><,./=]/;
  const numbers = '0123456789';
  const lowercaseChars = 'abcdefghijklmnopqrstuvwxyz';
  const uppercaseChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const guessesPerSecond = 1_000_000_000;

  var passwordHasLowercase = /[a-z]/.test(password)
  var passwordHasUppercase = /[A-Z]/.test(password);
  var passwordHasLetters = passwordHasLowercase && passwordHasUppercase;
  var passwordHasNumbers =  /\d/.test(password);
  var passwordHasSpecialChars =  speciRegExp.test(password);

  var timeToCrackPasswordInSeconds = Math.pow((passwordHasLowercase ? lowercaseChars.length : 0) + (passwordHasUppercase ? uppercaseChars.length : 0) + (passwordHasNumbers ? numbers.length : 0) + (passwordHasSpecialChars ? specialChars.length : 0), password.length) / guessesPerSecond


  const [settingsTimeToCrackInSeconds, setSettingsTimeToCrackInSeconds] = React.useState<number>(Math.pow((includeLowercase ? lowercaseChars.length : 0) + (includeUppercase ? uppercaseChars.length : 0) + (includeNumbers ? numbers.length : 0) + (includeSpecialChars ? specialChars.length : 0), password.length) / guessesPerSecond); 


  const generatePassword = (incUppercase: boolean, inLowercase: boolean, inNumbers: boolean, inSpecials: boolean, passLength: number): void => {
    const button = document.querySelector('.refresh-button') as HTMLButtonElement;
    button.classList.add('clicked');
  
    // Ensure the animation class is removed after the animation completes
    setTimeout(() => {
      button.classList.remove('clicked');
    }, 500); // Duration should match the CSS animation duration


    let charset = '';
    let passwordArray: string[] = [];
    let remainingLength = passLength;
  
    if (incUppercase) {
      charset += uppercaseChars;
      passwordArray.push(uppercaseChars.charAt(Math.floor(Math.random() * uppercaseChars.length)));
      remainingLength--;
    }

    if (inLowercase) {
      charset += lowercaseChars;
      passwordArray.push(lowercaseChars.charAt(Math.floor(Math.random() * lowercaseChars.length)));
      remainingLength--;
    }
  
    if (inNumbers) {
      charset += numbers;
      passwordArray.push(numbers.charAt(Math.floor(Math.random() * numbers.length)));
      remainingLength--;
    }
  
    if (inSpecials) {
      charset += specialChars;
      passwordArray.push(specialChars.charAt(Math.floor(Math.random() * specialChars.length)));
      remainingLength--;
    }

    remainingLength = Math.max(remainingLength, 0);
  
    for (let i = 0; i < remainingLength; ++i) {
      if (charset.length === 0) {
        console.error("Charset is empty; cannot generate password.");
        return;
      }
      passwordArray.push(charset.charAt(Math.floor(Math.random() * charset.length)));
    }
  
    for (let i = passwordArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [passwordArray[i], passwordArray[j]] = [passwordArray[j], passwordArray[i]];
    }
  
    // Convert the array to a string and set the password
    setPassword(passwordArray.join(''));
    setCopied(false); // Reset copied state when a new password is generated
  };
  
  



  const formatNumber = (num: number): string => {
    return num.toLocaleString();
  };

  const formatSeconds = (seconds: number): string => {
    const timeToCrackMinutes = seconds / 60;
    const timeToCrackHours = timeToCrackMinutes / 60;
    const timeToCrackDays = timeToCrackHours / 24;
    const timeToCrackMonths = timeToCrackDays / 30;
    const timeToCrackYears = timeToCrackMonths / 12;

    if (timeToCrackYears > 10_000_000_000_000_000) {
      return `${Math.round(timeToCrackYears)} years`;
    } else if (timeToCrackDays > 365) {
      return `${formatNumber(Math.round(timeToCrackDays / 365))} years`;
    } else if (timeToCrackHours > 24) {
      return `${Math.round(timeToCrackDays)} days`;
    } else if (timeToCrackMinutes > 60) {
      return `${Math.round(timeToCrackHours)} hours`;
    } else if (timeToCrackMinutes > 1){
      return `${Math.round(timeToCrackMinutes)} minutes`;
    } else {
      return `${Math.round(timeToCrackMinutes)} minute`;
    }
  };
  
  const handlePasswordChange = () => {
    setPasswordClass('password fade-out');
    setTimeout(() => {
      generatePassword(includeUppercase, includeLowercase, includeNumbers, includeSpecialChars, passwordLength);
      setPasswordClass('password fade-in');
    }, 500);
  };



  const copyToClipboard = (): void => {
    if (password) {
      navigator.clipboard.writeText(formattedPassword).then(() => {
        setCopied(true);
      }, () => {
        setCopied(false);
      });
    }
  };

  React.useEffect(() => {
    generatePassword(includeUppercase, includeLowercase, includeNumbers, includeSpecialChars, passwordLength);
  },[])

  React.useEffect( () => {
    setSettingsTimeToCrackInSeconds(Math.pow((includeLowercase ? lowercaseChars.length : 0) + (includeUppercase ? uppercaseChars.length : 0) + (includeNumbers ? numbers.length : 0) + (includeSpecialChars ? specialChars.length : 0), passwordLength) / guessesPerSecond)
  },[includeLowercase, includeUppercase, includeNumbers, includeSpecialChars, passwordLength])

  React.useEffect( () => {
    setFormattedPassword(formatPassword(password))
  }, [password, withSeparators])


  return (
    <div className="App">
      <header style={{display: "flex",flexDirection: "column", gap: 10}} className="App-header">
        {password &&
          <code className={passwordClass} style={{wordWrap: "break-word"}} onClick={copyToClipboard}>{formattedPassword}</code>
        }
                <code style={{fontSize:"1rem"}}>{formatSeconds(timeToCrackPasswordInSeconds)}</code>
        <code style={{height: "1rem", fontSize:"1rem"}}>{copied ? "copied!" : ""}</code>
        <button onClick={handlePasswordChange} className="refresh-button">
          <FontAwesomeIcon icon={faSyncAlt} />
        </button>
        <div>
        <div style={{display: "flex", flexDirection: "column", gap:10, fontSize: "1rem", marginTop:20, alignItems: "flex-start", marginLeft:0}} className="checkbox-container">
          <code>
            <FontAwesomeIcon 
              icon={includeUppercase ? faCheckSquare : faSquare} 
              onClick={() => setIncludeUppercase(!includeUppercase)} 
              className="checkbox-icon" 
            />
            <label style={{marginLeft:10}} htmlFor="letters" onClick={() => setIncludeUppercase(!includeUppercase)}>uppercase</label>
          </code>
          <code>
            <FontAwesomeIcon 
              icon={includeLowercase ? faCheckSquare : faSquare} 
              onClick={() => setIncludeLowercase(!includeLowercase)} 
              className="checkbox-icon" 
            />
            <label style={{marginLeft:10}} htmlFor="letters" onClick={() => setIncludeLowercase(!includeLowercase)}>lowercase</label>
          </code>
          <code>
            <FontAwesomeIcon 
              icon={includeNumbers ? faCheckSquare : faSquare} 
              onClick={() => setIncludeNumbers(!includeNumbers)} 
              className="checkbox-icon" 
            />
            <label style={{marginLeft:10}} htmlFor="numbers" onClick={() => setIncludeNumbers(!includeNumbers)}>numbers</label>
          </code>
          <code>
            <FontAwesomeIcon 
              icon={includeSpecialChars ? faCheckSquare : faSquare} 
              onClick={() => setIncludeSpecialChars(!includeSpecialChars)} 
              className="checkbox-icon" 
            />
            <label style={{marginLeft:10}} htmlFor="specials" onClick={() => setIncludeSpecialChars(!includeSpecialChars)}>specials</label>
          </code>
          <code>
            <FontAwesomeIcon 
              icon={withSeparators ? faCheckSquare : faSquare} 
              onClick={() => setWithSeparators(!withSeparators)} 
              className="checkbox-icon" 
            />
            <label style={{marginLeft:10}} htmlFor="separators" onClick={() => setWithSeparators(!withSeparators)}>separators</label>
          </code>
        </div>
        <div style={{display: "flex", flexDirection: "row", gap:10, fontSize: "1rem", marginTop:20, alignItems: "flex-start", marginLeft:0}} className="radio-container">
        <code>
            <input
              type="radio"
              id="parano"
              name="passwordLength"
              checked={passwordLength === 8}
              onChange={() => setPasswordLength(8)}
            />
            <label style={{marginLeft:10}} htmlFor="easy">8</label>
          </code>
        <code>
            <input
              type="radio"
              id="parano"
              name="passwordLength"
              checked={passwordLength === 12}
              onChange={() => setPasswordLength(12)}
            />
            <label style={{marginLeft:10}} htmlFor="parano">12</label>
          </code>
          <code>
            <input
              type="radio"
              id="parano"
              name="passwordLength"
              checked={passwordLength === 16}
              onChange={() => setPasswordLength(16)}
            />
            <label style={{marginLeft:10}} htmlFor="parano">16</label>
          </code>
          <code>
            <input
              type="radio"
              id="ultra-parano"
              name="passwordLength"
              checked={passwordLength === 24}
              onChange={() => setPasswordLength(24)}
            />
            <label style={{marginLeft:10}} htmlFor="ultra-parano">24</label>
          </code>
          <code>
            <input
              type="radio"
              id="mega-parano"
              name="passwordLength"
              checked={passwordLength === 32}
              onChange={() => setPasswordLength(32)}
            />
            <label style={{marginLeft:10}} htmlFor="mega-parano">32</label>
          </code>
        </div>
        </div>
        <code style={{fontSize:"1rem"}}>{formatSeconds(settingsTimeToCrackInSeconds)}</code>
      </header>
    </div>
  );
}

export default App;
